import classes from './mapDrawerContent.module.css';

interface Props {
  label: string;
  value: string;
}

const DetailRow = ({ label, value }: Props) => {
  return (
    <div className={classes.detailRowContainer}>
      <div className={classes.detailRowLabel}>{label}:</div>
      <div className={classes.detailRowValue}>{value}</div>
    </div>
  );
};

export default DetailRow;
